// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Q26y-","left-container":"classes_left-container__9+nQt","icon":"classes_icon__lr0U4","icon-trash":"classes_icon-trash__JPrI-"};